<template>
  <div class="user">
    <!--
    <div class="photo">
      <img src="static/img/faces/face-2.jpg"/>
    </div>
    -->
    <div class="info">
      <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
           <span>
             <div class="username">{{username}}</div>
             <b class="caret"></b>
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <li>
              <a href="javascript:void(0)">
                <i class="sidebar-mini fa fa-user"></i>
                <span class="sidebar-normal">My Account</span>
              </a>
            </li>
            <li>
              <a @click="logout" href="javascript:void(0)">
                <i class="sidebar-mini fa fa-sign-out"></i>
                <span class="sidebar-normal">Logout</span>
              </a>
            </li>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  import ModalOptions from 'src/components/ModalPlugin/ModalOptions'
  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data () {
      return {
        isClosed: true
      }
    },
    computed: {
      username () {
        return this.$store.state.username
      }
    },
    methods: {
      logout () {
        this.$modal.show(ModalOptions,
            {
              title: "Logout?",
              message: "Are you sure you want to log out?",
              message2: "Any unsaved changes you have made will be lost!",
              closeText: "Cancel",
              actionText1: "Logout",
              closeAction: () => 
                {
                  this.$modal.close()
                },
              action1: () => 
                {
                  this.$modal.close()
                  this.$api.logout()
                    .then(reponse => {
                      this.$store.commit('logout')
                      this.$router.push('/login')
                    })
                }
              })
      },
      toggleMenu () {
        this.isClosed = !this.isClosed
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>
